import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { CORE_ROUTE } from "@obg/ngx.core";
import { PlatformService } from "@obg/ngx.global.evo";
import { RouteAction } from "@obg/ngx.router";
import { isEmpty } from "lodash-es";
import { Observable, timer } from "rxjs";
import { exhaustMap, filter, switchMap } from "rxjs/operators";

import { GamingExternalState } from "../state";

import { GameCollectionAction } from "./game-collection.action";
import { GameCollectionSelector } from "./game-collection.selector";

@Injectable({
	providedIn: "root",
})
export class GameCollectionExistsGuard implements CanActivate {
	constructor(
		private store: Store<GamingExternalState>,
		private action: GameCollectionAction,
		private location: Location,
		private platformService: PlatformService,
		private selector: GameCollectionSelector
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const collectionSlug = route.params.category;

		return this.store.pipe(
			select(this.selector.getAll()),
			exhaustMap((x) => {
				if (!isEmpty(x)) {
					// todo: OBGD-1545 - investigate why this fixes the page doesn't load on refresh issue
					return Promise.resolve(undefined);
				}

				this.store.dispatch(this.action.getAll());

				return this.store.pipe(
					select(this.selector.getAll()),
					filter((gameCollections) => !isEmpty(gameCollections))
				);
			}),
			exhaustMap(() => this.store.pipe(select(this.selector.getBySlug(collectionSlug)))),
			switchMap((collection) => {
				if (!isEmpty(collection)) {
					// todo: OBGD-1545 - investigate why this fixes the page doesn't load on refresh issue
					return Promise.resolve(true);
				}

				this.store.dispatch(RouteAction.navigate(CORE_ROUTE.notFound, undefined, { skipLocationChange: true }));
				// todo: remove when solved: https://github.com/angular/angular/issues/16981
				this.platformService.forClient(() => timer(0)).subscribe(() => this.location.replaceState(state.url)); // eslint-disable-line rxjs/no-ignored-subscription
				// todo: OBGD-1545 - investigate why this fixes the page doesn't load on refresh issue
				return Promise.resolve(false);
			})
		);
	}
}
